<!--
    描述： 项目基本信息中的基本信息
    时间： xx
    created by ws
-->
<template>
	<div class="h100"
		 v-loading="loading">
		<div class="baseForm-layout">
			<div class="baseForm-header overflow-hidden">基本信息
				<!-- <div class="btnGroups"
					 v-if="showToolsBtn">
					<el-button size="mini"
							   @click="isDisabled = !isDisabled">
						{{ isDisabled ? '解锁' : '锁定' }}
					</el-button>
					<el-button size="mini"
							   type="primary"
							   :loading="btnLoading"
							   @click="saveData">保存
					</el-button>
				</div> -->
			</div>
			<div class="baseForm-content">
				<el-form label-width="160px"
						 ref="baseForm"
						 :model="formInfo"
						 :rules="formRules">
					<el-row>
						<el-col :span="12">
							<el-form-item label="工程名称">
								<el-input v-model="formInfo.projectName"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="工程来源">
								<el-select v-model="formInfo.projectResource"
										   :disabled="isDisabled"
										   placeholder="请选择">
									<el-option v-for="(item, index) in resourcesList"
											   :key="'来源' + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="工程类型">
								<el-select v-model="formInfo.projectType"
										   :disabled="isDisabled"
										   placeholder="请选择">
									<el-option v-for="(item, index) in typeList"
											   :key="'地区' + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所在地区">
								<el-cascader v-model="formInfo.curArea"
											 :options="areaList"
											 :disabled="isDisabled"
											 @change="handleChange"
											 placeholder="请选择"></el-cascader>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="建设单位">
								<el-input v-model="formInfo.companyBuild"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="设计单位">
								<el-input v-model="formInfo.companyDesign"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="施工单位">
								<el-input v-model="formInfo.companyConstruction"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="监理单位">
								<el-input v-model="formInfo.companySupervision"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="招标方式">
								<el-select v-model="formInfo.tenderType"
										   :disabled="isDisabled"
										   placeholder="请选择">
									<el-option v-for="(item, index) in biddingList"
											   :key="'招标方式' + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="招标代理">
								<el-input v-model="formInfo.tenderAgentCompany"
										  :disabled="isDisabled"
										  placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="立项日期">
								<el-date-picker v-model="formInfo.approvalDate"
												:disabled="isDisabled"
												type="date"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												placeholder="请选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="交付日期">
								<el-date-picker v-model="formInfo.deliveryDate"
												:disabled="isDisabled"
												type="date"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												placeholder="请选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="开工日期">
								<el-date-picker v-model="formInfo.startDate"
												:disabled="isDisabled"
												type="date"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												placeholder="请选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="竣工日期">
								<el-date-picker v-model="formInfo.completeDate"
												:disabled="isDisabled"
												type="date"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												placeholder="请选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="概算金额"
										  prop="moneyEstimatedPrice">
								<el-input v-model="formInfo.moneyEstimatedPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="建安工程概算价"
										  prop="moneyInstallEstimatedPrice">
								<el-input v-model="formInfo.moneyInstallEstimatedPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="控制价">
								<el-input v-model="formInfo.moneyControlPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="中标价">
								<el-input v-model="formInfo.moneyBidPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="合同价">
								<el-input v-model="formInfo.moneyContractPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="报审价">
								<el-input v-model="formInfo.moneyReportPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="初审价">
								<el-input v-model="formInfo.moneyInitialPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="审定价">
								<el-input v-model="formInfo.moneyAuthorizedPrice"
										  :disabled="isDisabled"
										  type="number"
										  placeholder="请输入">
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>

		<!-- 动态模板生成 -->
		<div class="baseForm-layout"
			 v-for="(item, index) in templateList"
			 :key="'模板' + index">
			<div class="baseForm-header overflow-hidden">{{ item.sname }}</div>
			<div class="baseForm-content">
				<el-form label-width="160px">
					<el-row>
						<el-col :span="12"
								v-for="(m, n) in item.fieldList"
								:key="'字段' + index + n">
							<el-form-item :label="m.title">
								<!-- formType标段类型 -->
								<!-- 1005001 数值型 -->
								<el-input v-if="m.formType === '1005001'"
										  v-model="m.value"
										  type="number"
										  placeholder="请输入"
										  :disabled="isDisabled || m.isEditable === 0">
									<template slot="append"
											  v-if="m.additional.suffix && m.additional.suffix !== ''">
										<span>{{ m.additional.suffix }}</span>
									</template>
								</el-input>

								<!-- 1005002 文本型 -->
								<el-input v-if="m.formType === '1005002'"
										  v-model="m.value"
										  placeholder="请输入"
										  :disabled="isDisabled  || m.isEditable === 0">
									<template slot="append"
											  v-if="m.additional.suffix && m.additional.suffix !== ''">
										<span>{{ m.additional.suffix }}</span>
									</template>
								</el-input>

								<!-- 1005003 日期型 -->
								<el-date-picker v-if="m.formType === '1005003'"
												v-model="m.value"
												:disabled="isDisabled || m.isEditable === 0"
												:type="m.additional.dateType"
												format="yyyy 年 MM 月 dd 日"
												value-format="yyyy-MM-dd"
												placeholder="请选择日期">
								</el-date-picker>

								<!-- 1005004 文件型 -->
								<el-input v-if="m.formType === '1005004'"
										  v-model="m.value"></el-input>

								<!-- 1005005 文本（textarea） -->
								<el-input v-if="m.formType === '1005005'"
										  type="textarea"
										  :autosize="{ minRows: 1}"
										  :disabled="isDisabled || m.isEditable === 0"
										  placeholder="请输入内容"
										  v-model="m.value">
								</el-input>

								<!-- 1005006 下拉选择型 -->
								<el-select v-if="m.fieldId === '1263005747355123714'"
										   v-model="m.infoValue"
										   :disabled="isDisabled || m.isEditable === 0"
										   @change="handleChangeMonth($event, m)"
										   style="width: 47%"
										   placeholder="请选择">
									<el-option v-for="(item, index) in m.additional.options"
											   :key="item.value + index"
											   :label="item.value"
											   :value="item.value">
									</el-option>
								</el-select>
								<span v-if="m.fieldId === '1263005747355123714'" style="display: inline-block; width: 6%; text-align: center">—</span>
								<el-date-picker v-if="m.fieldId === '1263005747355123714'"
												style="width: 47%"
												value-format="yyyy-MM"
												type="month"
												:disabled="isDisabled || m.isEditable === 0"
												@change="handleChangeMonth($event, m)"
												v-model="m.infoMonth"
												placeholder="选择年月">
								</el-date-picker>

								<!-- 1005007 系统码表型 -->
								<el-select v-if="m.formType === '1005007'"
										   v-model="m.value"
										   :disabled="isDisabled || m.isEditable === 0"
										   placeholder="请选择">
									<el-option v-for="(item, index) in m.options"
											   :key="item.value + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
	</div>

</template>

<script>
import { mapState } from 'vuex'
import { getAllAreaTree, getDictByParentValue } from '@/api/modules/dict.js'
import {
	getFieldsAndValue,
	saveBasicInfoProjects
} from '@/api/modules/analysis'
import { updateBusProContract } from '@/api/modules/dataProject'

export default {
	name: 'base-info',
	props: {
		// 是否展示编辑保存按钮
		showToolsBtn: {
			type: Boolean,
			default: false
		}
	},
	data() {
		// 概算价验证
		let checkMoney = (rule, value, callback) => {
			setTimeout(() => {
				if (
					value < parseFloat(this.formInfo.moneyInstallEstimatedPrice)
				) {
					callback(new Error('概算金额 需大于 建安工程费'))
				} else {
					callback()
				}
			}, 500)
		}
		// 建安工程费验证
		let checkInstall = (rule, value, callback) => {
			setTimeout(() => {
				if (value > parseFloat(this.formInfo.moneyEstimatedPrice)) {
					callback(new Error('建安工程费不得 大于 概算金额'))
				} else {
					callback()
				}
			}, 500)
		}
		return {
			areaList: [],
			formInfo: {
				//项目名称
				projectName: '',
				//项目来源
				projectResource: '',
				//工程类型
				projectType: '',
				//所在区域-单个
				area: [],
				//数组-地区
				curArea: [],
				//建设单位
				companyBuild: '',
				//设计单位
				companyDesign: '',
				//施工单位
				companyConstruction: '',
				//监理单位
				companySupervision: '',
				//招标方式
				tenderType: '',
				//招标代理
				tenderAgentCompany: '',
				//立项日期
				approvalDate: '',
				//交付日期
				deliveryDate: '',
				//开工日期
				startDate: '',
				//竣工日期
				completeDate: '',
				//概算金额
				moneyEstimatedPrice: '',
				//其中建安工程费
				moneyInstallEstimatedPrice: '',
				//控制价
				moneyControlPrice: '',
				//中标价
				moneyBidPrice: '',
				//合同价
				moneyContractPrice: '',
				//报审价
				moneyReportPrice: '',
				//初审价
				moneyInitialPrice: '',
				//审定价
				moneyAuthorizedPrice: ''
			},
			// 规则验证
			formRules: {
				// 概算金额
				moneyEstimatedPrice: [
					{ validator: checkMoney, trigger: 'blur' }
				],
				// 建安工程费
				moneyInstallEstimatedPrice: [
					{ validator: checkInstall, trigger: 'blur' }
				]
			},
			// 模板数组列表
			templateList: [],
			// 是否可编辑
			isDisabled: true,
			// 页面等待状态
			loading: false,
			// 按钮等待状态
			btnLoading: false
		}
	},
	methods: {
		//获取地区字典值
		getAreaList() {
			getAllAreaTree({})
				.then(res => {
					this.areaList = res.data
				})
				.catch(err => {})
		},

		// 地区级联下拉框切换事件
		handleChange(val) {
			this.formInfo.area = val[val.length - 1]
		},

		// 信息价依据 - 月份选择
		handleChangeMonth(val, obj) {
			obj.value = obj.infoValue + ',' + obj.infoMonth
		},

		// 获取动态模板数据
		getTemplate() {
			this.loading = true
			getFieldsAndValue({ aid: this.curProjectId })
				.then(res => {
					// 动态区块数据
					res.data.blockList.forEach(x => {
						x.fieldList.map(y => {
							// 系统码表
							if (y.formType === '1005007' || y.formType === '1005009') {
								this.getDict(
                    y.additional.dictionaryType
								).then(res => {
									y.options = res
								})
								// console.log(y.options)
							}

							// 信息价依据
							if (y.formType === '1005006' && y.fieldId === '1263005747355123714') {
								let arr = y.value.split(',')
								y.infoValue = arr.length > 0 ? arr[0] : ''
								y.infoMonth = arr.length > 0 ? arr[1] : ''
							}

						})
					})
					setTimeout(() => {
						this.loading = false
						this.formInfo = Object.assign({}, res.data.projectInfo)
						// 地区数组单独处理
						this.formInfo.curArea = []
						this.formInfo.curArea.push(res.data.projectInfo.city)
						this.formInfo.curArea.push(res.data.projectInfo.area)

						this.templateList = res.data.blockList
					}, 500)
				})
				.catch(err => {
					this.loading = false
					// console.log(err)
				})
		},

		// 获取码表数组
		async getDict(value) {
			let res = await getDictByParentValue({ value: value })

			if (res.code === 0) {
				return res.data
			} else {
				return []
			}
		},

		// 保存数据
		saveData() {
			this.btnLoading = true
			let params = Object.assign([], this.templateList)
			let _info = Object.assign({}, this.formInfo)

			this.$refs.baseForm.validate(valid => {
				if (valid) {
					// 先保存基本信息
					updateBusProContract(_info)
						.then(res => {
							setTimeout(() => {
								this.btnLoading = false

								this.getTemplate()
							}, 2000)
						})
						.catch(err => {
							this.$message.error(err)
							setTimeout(() => {
								this.btnLoading = false
							}, 2000)
						})

					// 再保存 动态表单
					saveBasicInfoProjects(params)
						.then(res => {
							setTimeout(() => {
								this.btnLoading = false
							}, 2000)
							if (res.operationCode == 1) {
								// console.log(res.message)
								this.$message.success('保存成功!')
								this.isDisabled = true
								this.$emit('onSuccess')
							}
						})
						.catch(err => {
							this.$message.error(err)
							setTimeout(() => {
								this.btnLoading = false
							}, 2000)
						})
				} else {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
					return false
				}
			})
		}
	},

	created() {
		this.getAreaList()

		// 获取模板信息
		this.getTemplate()
	},

	computed: {
		...mapState('dict', {
			resourcesList: state => state.gcly, // 工程来源数组
			typeList: state => state.gclx, // 工程类型数组
			biddingList: state => state.zbfs, // 招标方式数组
			bdlx: state => state.bdlx // 标段类型
		}),

		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
	},

	watch: {
		// 监听对象的变化
		// projectMessage: {
		// 	handler: function(obj) {
		// 		this.formInfo = Object.assign({}, obj)
		// 		this.formInfo.curArea = []
		// 		this.formInfo.curArea.push(obj.city)
		// 		this.formInfo.curArea.push(obj.area)
		// 	},
		// 	deep: true
		// }
	}
}
</script>
<style lang="less" scoped></style>
